var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import initialWalletControllerState from "../constants/initialWalletControllerState";
var reducer = function (state, action) {
    switch (action.type) {
        case "SET_WEB3_PROVIDER":
            return __assign(__assign({}, state), { provider: action.provider, web3Provider: action.web3Provider, address: action.address, chainId: action.chainId });
        case "SET_ADDRESS":
            return __assign(__assign({}, state), { address: action.address });
        case "SET_CHAIN_ID":
            return __assign(__assign({}, state), { chainId: action.chainId });
        case "RESET_WEB3_PROVIDER":
            return initialWalletControllerState;
        default:
            throw new Error();
    }
};
export default reducer;
